import { render, staticRenderFns } from "./goodsSelector.vue?vue&type=template&id=49b27d4d&scoped=true&"
import script from "./goodsSelector.vue?vue&type=script&lang=js&"
export * from "./goodsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b27d4d",
  null
  
)

export default component.exports